import * as React from "react";
import { cn } from "../../lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...props }: InputProps) {
  return (
    <input
      className={cn(
        "bg-transparent text-white text-sm font-medium outline-none placeholder:text-neutral-600",
        className,
      )}
      {...props}
    />
  );
}

Input.displayName = "Input";
